
export default {
    name: 'EnterpriseLoginLogoTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        },
        update: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        // logo seleccionado
        logoSelected: null,
        // imagen de fondo seleccionada
        backgroundImageSelected: null,
        // model del dialog de vista previa
        preview: false,
        // models del preview
        usernamePreview: '',
        passwordPreview: '',
        showPasswordPreview: false,
        rememberPreview: false,
        previewBackgroundImage: '../../../../../assets/login-background.jpg'
    }),
    computed: {
        /**
         * Src del logo
         */
        logoSource() {
            if (this.model.loginLogo) {
                return 'data:image/png;base64,' + this.model.loginLogo
            } else {
                return require('../../../../../assets/logo.png');
            }
        },
        /**
         * Src de la imagen de fondo
         */
        backgroundImageSource() {
            if (this.model.loginBackgroundImage) {
                return 'data:image/png;base64,' + this.model.loginBackgroundImage
            } else {
                return require('../../../../../assets/login-background.jpg');
            }
        }
    },
    created () {
    },
    mounted () {
    },
    methods: {
        /**
         * Cuando selecciona la imágen, convierte a BASE64 y la asigna al model
         * @param {*} files
         */
        onFileSelected(file, logo = true) {
            if (file) {
                // base 64 (para guardar en el modelo)
                const binaryReader = new FileReader()
                binaryReader.readAsBinaryString(file)
                binaryReader.onload = () => {
                    if (logo) {
                        this.model.loginLogo = btoa(binaryReader.result)
                    } else {
                        this.model.loginBackgroundImage = btoa(binaryReader.result)
                    }
                }
                binaryReader.onerror = () => {
                    console.error('Error al leer la imagen subida');
                }
            } else {
                if (logo) {
                    this.model.loginLogo = null
                } else {
                    this.model.loginBackgroundImage = null
                }
            }
        },
        /**
         * Elimina el logo seleccionado
         */
        deleteLogo() {
            this.model.loginLogo = null
            this.logoSelected = null
        },
        /**
         * Elimina la imágen de fondo seleccionada
         */
        deleteBackgroundImage() {
            this.model.loginBackgroundImage = null
            this.backgroundImageSelected = null
        },
        /**
         * Para mostrar el dialog de vista previa
         */
        showPreview() {
            this.preview = true
        }
    },
    watch: {
        /**
         * Para validar el formulario
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.enterpriseLoginForm) {
                this.$refs.enterpriseLoginForm.resetValidation()
            }
        }
    }
}
